import * as localforage from "localforage";
// localforage.config({
// 	driver      : localforage.INDEXEDDB,
// 	name        : 'Immo',
// 	version     : 1.0,
// 	size        : 4980736,
// 	storeName   : 'omnicasa',
// 	description : 'Omnicasa Web application'
// });
const localforageCommon = localforage.createInstance({
	driver      : localforage.INDEXEDDB,
	name        : 'Immo',
	version     : 1.0,
	size        : 4980736,
	storeName   : 'omnicasa',
	description : 'Omnicasa Web application'
})

export class LocalforageWrapper{
	instance: LocalForage;
	constructor(options?: Object | {}) {
		this.instance = localforageCommon.createInstance(Object.assign({}, options));
	}
	static getItem<T>(key: string, callback?: (err: any, value: T) => void): Promise<T> {
		return localforageCommon.getItem(key, callback);
	}
	
	static setItem<T>(key: string, value: T, callback?: (err: any, value: T) => void): Promise<T> {
		return localforageCommon.setItem(key, value, callback);
	}
	
	static removeItem(key: string, callback?: (err: any) => void): Promise<void> {
		return localforageCommon.removeItem(key, callback);
	}
	
	static clear(callback?: (err: any) => void): Promise<void> {
		return localforageCommon.clear(callback);
	}
	
	length(callback?: (err: any, numberOfKeys: number) => void): Promise<number> {
		return localforageCommon.length(callback);
	}
	
	static key(keyIndex: number, callback?: (err: any, key: string) => void): Promise<string> {
		return localforageCommon.key(keyIndex, callback);
	}
	
	static keys(callback?: (err: any, keys: string[]) => void): Promise<string[]> {
		return localforageCommon.keys(callback);
	}
	
	static iterate<T, U>(iteratee: (value: T, key: string, iterationNumber: number) => U,
	              callback?: (err: any, result: U) => void): Promise<U> {
		return localforageCommon.iterate(iteratee, callback);
	}
}

interface LocalForage extends LocalForageDbMethods {
	LOCALSTORAGE: string;
	WEBSQL: string;
	INDEXEDDB: string;
	
	config(options: LocalForageOptions): boolean;
	config(options: string): any;
	config(): LocalForageOptions;
	
	createInstance(options: LocalForageOptions): LocalForage;
	
	driver(): string;
	
	setDriver(driver: string | string[], callback?: () => void, errorCallback?: (error: any) => void): Promise<void>;
	
	defineDriver(driver: LocalForageDriver, callback?: () => void, errorCallback?: (error: any) => void): Promise<void>;
	
	getDriver(driver: string): Promise<LocalForageDriver>;
	
	getSerializer(callback?: (serializer: LocalForageSerializer) => void): Promise<LocalForageSerializer>;
	
	supports(driverName: string): boolean;
	
	ready(callback?: (error: any) => void): Promise<void>;
}

export interface LocalForageDbMethods extends LocalForageDbMethodsCore, LocalForageDbMethodsOptional {}

interface LocalForageDbMethodsOptional {
	dropInstance: LocalForageDropInstanceFn;
}

interface LocalForageDbInstanceOptions {
	name?: string;
	storeName?: string;
}

interface LocalForageDropInstanceFn {
	(dbInstanceOptions?: LocalForageDbInstanceOptions, callback?: (err: any) => void): Promise<void>;
}

interface LocalForageDbMethodsCore {
	getItem<T>(key: string, callback?: (err: any, value: T) => void): Promise<T>;
	
	setItem<T>(key: string, value: T, callback?: (err: any, value: T) => void): Promise<T>;
	
	removeItem(key: string, callback?: (err: any) => void): Promise<void>;
	
	clear(callback?: (err: any) => void): Promise<void>;
	
	length(callback?: (err: any, numberOfKeys: number) => void): Promise<number>;
	
	key(keyIndex: number, callback?: (err: any, key: string) => void): Promise<string>;
	
	keys(callback?: (err: any, keys: string[]) => void): Promise<string[]>;
	
	iterate<T, U>(iteratee: (value: T, key: string, iterationNumber: number) => U,
	              callback?: (err: any, result: U) => void): Promise<U>;
}